<form [formGroup]="form" (submit)="toNextStep()">
    <mg-configurator-content *ngIf="route$ | async as route">
        <mg-configuration-options-factory
            *ngIf="configurationId && routeCategory$ | async as routeCategory"
            [configurationId]="configurationId"
            [form]="form"
            [category]="routeCategory"
            [routeIndex]="route.index"
        >
            <mg-configuration-factory-tabs class="above-content" position="top"></mg-configuration-factory-tabs>

            <mg-ui-card class="config-save">
                <div *ngIf="needsUserProfile$ | async" class="userProfile">
                    <h1 i18n="@@deals.user-profile.title">Your profile</h1>
                    <p class="typography-text-white typography-headline-5" i18n="@@deals.user-profile.description">
                        Before we configure your offer further we need a bit more information about you.
                    </p>
                    <mg-deal-user-profile
                        #userProfileSubmit
                        (change)="onUserProfileChange(userProfileSubmit.valid)"
                        [displayAddress]="false"
                        [displayName]="true"
                        [displayPhonenumber]="true"
                        [isEditing]="true"
                    ></mg-deal-user-profile>
                </div>

                <ng-container *ngIf="!userIsLoggedInOnInit">
                    <h1 i18n="@@configurator.proceed-step-one.title">Save your configuration</h1>
                    <p i18n="@@configurator.proceed-step-one.description">
                        Your e-mail address will be saved and used to contact you about this offer.
                    </p>
                    <mg-login-submit
                        (submit)="toNextStep()"
                        [isGhost]="true"
                        [submitDisabled]="form.invalid"
                        i18n="@@configurator.general.next-step-button"
                        >Next step</mg-login-submit
                    >
                </ng-container>

                <mg-ui-button
                    identifier="button-next-step-{{ route.nextRoute && route.nextRoute.id }}"
                    *ngIf="userIsLoggedInOnInit"
                    [disabled]="form.invalid || (nextRouteAvailable$ | async) !== true || !userProfileValid"
                    [yellowTheme]="true"
                    [scrollToInvalid]="true"
                    type="submit"
                    errorMessage="Not all mandatory fields have been filled in"
                    i18n-errorMessage="@@configurator.general.next-step-button.error-message"
                >
                    <ng-container *ngIf="route.id === 'configurator'" i18n="@@configurator.general.button-step-one">
                        Choose duration & mileage
                    </ng-container>
                    <ng-container *ngIf="route.id === 'contract'" i18n="@@configurator.general.button-step-two">
                        Choose deductible & downpayment
                    </ng-container>
                    <ng-container *ngIf="route.id === 'calibrate'" i18n="@@configurator.general.button-step-three">
                        Fill in your contact details
                    </ng-container>
                    <ng-container *ngIf="route.id === 'confirm'" i18n="@@configurator.general.button-step-four"
                        >View your offer</ng-container
                    >
                </mg-ui-button>
            </mg-ui-card>

            <mg-configuration-factory-tabs position="bottom"></mg-configuration-factory-tabs>
        </mg-configuration-options-factory>
    </mg-configurator-content>
</form>
